/* VIPet Store — add-to-cart celebration.
   A small "bite" out of the button, a paw burst, and a tail wag on the cart icon.
   Delegated from document so it also covers quick-add buttons and the
   product page form, including cards rendered after load. */
(function () {
  var PAWS = 9;

  function reduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function bite(btn) {
    var mark = document.createElement('span');
    mark.className = 'vipet-bite-mark';
    btn.appendChild(mark);
    setTimeout(function () { mark.remove(); }, 560);

    btn.classList.remove('vipet-chomp');
    void btn.offsetWidth;
    btn.classList.add('vipet-chomp');
    btn.addEventListener('animationend', function handler() {
      btn.classList.remove('vipet-chomp');
      btn.removeEventListener('animationend', handler);
    });
  }

  function paws(btn) {
    var r = btn.getBoundingClientRect();
    var cx = r.left + r.width / 2;
    var cy = r.top + r.height / 2;

    for (var i = 0; i < PAWS; i++) {
      var p = document.createElement('span');
      p.className = 'vipet-paw-fly';
      p.textContent = '🐾';
      p.style.left = cx + 'px';
      p.style.top = cy + 'px';
      p.style.fontSize = (13 + (i % 4) * 4) + 'px';
      document.body.appendChild(p);

      var angle = (Math.PI * 2 / PAWS) * i - Math.PI / 2 + (i % 2 ? 0.22 : -0.22);
      var dist = 66 + (i % 3) * 32;
      var dx = Math.cos(angle) * dist;
      var dy = Math.sin(angle) * dist - 24;

      var anim = p.animate([
        { transform: 'translate(-50%,-50%) scale(.35) rotate(0deg)', opacity: 1 },
        { transform: 'translate(' + (dx - 12) + 'px,' + (dy - 12) + 'px) scale(1.05) rotate(' + (i % 2 ? 155 : -155) + 'deg)', opacity: 0 }
      ], { duration: 700 + (i % 3) * 120, easing: 'cubic-bezier(.2,.7,.3,1)' });

      anim.onfinish = (function (node) {
        return function () { node.remove(); };
      })(p);
    }
  }

  function wag() {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    icon.classList.remove('vipet-wag');
    void icon.offsetWidth;
    icon.classList.add('vipet-wag');
    icon.addEventListener('animationend', function handler() {
      icon.classList.remove('vipet-wag');
      icon.removeEventListener('animationend', handler);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[name="add"], .product-form__submit');
    if (!btn || btn.disabled) return;

    /* Buttons that only open the variant picker are not an add — don't celebrate. */
    if (btn.textContent.indexOf('בחירת אופציה') !== -1) return;

    if (reduced()) { wag(); return; }

    bite(btn);
    paws(btn);
    wag();
  }, true);
})();
